
import React from 'react';
import { cn } from "@/lib/utils";

const WEEK_DAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

const WeekDaysHeader: React.FC = () => {
  return (
    <div className="grid grid-cols-7 gap-1 mb-2">
      {WEEK_DAYS.map((day, index) => (
        <div 
          key={day} 
          className={cn(
            "text-center text-sm font-medium text-gray-500 py-2",
            index === 0 || index === 6 ? "text-rose-500" : ""
          )}
        >
          {day}
        </div>
      ))}
    </div>
  );
};

export default WeekDaysHeader;
